const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  docContainer: {
    overflow: 'hidden',
    marginTop: '8px',
  },
  docFrame: {
    [theme.breakpoints.up('md')]: {
      border: '1px solid #CED1D6',
      borderRadius: '10px',
    },
    marginBottom: '1.5em',
  },
  PanelDocHeader: {
    borderBottom: '1px solid #CED1D6',
    marginLeft: '-14px',
    marginRight: '-14px',
    padding: '0 14px 1rem 14px',
    '&:last-child': {
      borderBottom: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0 0 1rem 0',
      margin: '0',
    },
  },
  docHeading: {
    fontSize: '18px',
    fontWeight: '600',
    color: theme.palette.primary.adgmBlack,
    marginBottom: '.75rem',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '1.5em',
    },
    textTransform: 'lowercase',
    '& > span': {
      display: 'inline-block',
      '&::first-letter': {
        textTransform: 'uppercase',
      },
    },
  },
  docPanelHeader: {
    padding: '16px 24px',
    background: theme.palette.primary.grey,
    borderBottom: '1px solid #CED1D6',
    marginBottom: `8px !important`,
  },
  panelBody: {
    padding: '0 24px',
  },
  docBox: {
    gap: '12px',
    background: theme.palette.primary.white,
    border: `1px solid ${theme.palette.primary.borderColor}`,
  },
  PanelDocBox: {
    gap: '12px',
    borderBottom: '1px solid #CED1D6',
    '&:last-child': {
      borderBottom: 'none',
      marginBottom: '10px',
    },
  },
  docIcon: {
    minWidth: '40px',
    minHeight: '40px',
    marginRight: '.5rem',
  },
  docUploadIcon: {
    background: '#0D2A3A',
  },
  pdfUploaded: {
    background: theme.palette.primary.white,
  },
  docName: {
    fontWeight: '600',
    color: theme.palette.primary.adgmBlack,
    display: 'flex',
    alignItems: 'center',
  },
  mandatory: {
    color: theme.palette.primary.darkErrorRed,
    display: 'inline-flex',
    transform: 'translate(5px, 4px)',
  },
  uploadIcon: {
    transition: 'all .3s ease',
  },
  fileActionsContainer: {
    gap: '.7rem',
    '& .MuiButton-root': {
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
      minWidth: '86px',
      '&.Mui-disabled': {
        borderColor: '#ced1d6',
      },
      '& p': {
        textTransform: 'capitalize',
        fontWeight: '600',
        fontSize: '14px',
        marginLeft: '5px',
      },
      // '&:hover': {
      //   '& $uploadIcon': {
      //     filter: 'invert(1)',
      //     // transform: 'scale(1.1)',
      //   },
      //   backgroundColor: theme.palette.primary.adgmHover,
      //   color: theme.palette.primary.white,
      //   border: 'none',
      // },
    },
  },
  viewBtn: {
    minHeight: '32px !important',
    background: '#fff',
  },
  fileActions: {
    background: 'none',
    '&:hover': {
      '& svg g path': {
        stroke: theme.palette.primary.white,
      },
      background: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
    },
  },
  delBtn: {
    paddingLeft: '6px',
    paddingRight: '6px',
    border: 'none !important',
    marginLeft: '12px',
    backgroundColor: 'none',
    '&:hover': {
      background: 'none !important',
      '& svg path': {
        fill: theme.palette.primary.main,
      },
    },
  },
  uploadedFileName: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '400',
  },
  fileSuccessIcon: {
    marginLeft: '6px',
  },
  removeDoc: {
    '& *': {
      fontSize: '14px',
    },
  },
  divider: {
    height: '2px',
    background: '#EBEEF3',
    margin: '12px 0px',
  },
  removeBtn: {
    color: theme.palette.secondary.errorRed,
    padding: '0',
  },
  // style for view docs
  docViewIcon: {
    // background: '#0D2A3A',
  },
  docViewTitle: {
    fontWeight: '600',
    fontSize: '14px',
    display: 'inherit',
  },
  docViewBox: {
    padding: '12px',
    background: theme.palette.primary.white,
    border: `1px solid ${theme.palette.primary.borderColor}`,
  },
  docViewContent: {
    // paddingLeft: '3rem',
    // borderBottom: '1px solid #EBEEF3',
  },
  impMessage: {
    fontSize: '14px',
  },
  errorAttribute: {
    fontSize: '14px',
    color: theme.palette.primary.errorRed,
  },
  downloadAllbtn: {
    color: theme.palette.primary.adgmSkyBlue,
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    padding: 0,
    textTransform: 'none',
    '& img': {
      marginRight: '5px',
    },
    '&:hover': {
      background: 'none',
    },
  },
  fileName: {
    fontSize: '12px',
  },
  actionBtn: {
    fontWeight: '500',
  },
  // for Error
  docBoxError: {
    borderColor: '#DF2C2C',
  },
  errMsg: {
    margin: '-.7rem 0 1.5rem',
    color: theme.palette.primary.main,
    fontSize: '14px',
  },
  [theme.breakpoints.up('up')]: {
    impMessage: {
      width: '50%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      '&:hover': {
        width: '100%',
        whiteSpace: 'normal',
        textOverflow: 'inherit',
      },
    },
  },
  [theme.breakpoints.up('sm')]: {
    docHeading: {
      fontSize: '18px',
      lineHeight: '31.5px',
      marginBottom: '1rem',
    },
    fileActionsContainer: {
      '& .MuiButton-root': {
        minHeight: '40px',
      },
    },
  },
  [theme.breakpoints.down('sm')]: {
    impMessage: {
      marginBottom: '12px',
    },
    fileActionsContainer: {
      flexDirection: 'column',
      '& .MuiButton-root': {
        width: '100%',
        '& p': {
          fontWeight: 500,
        },
      },
    },
    viewBtn: {
      marginLeft: '12px',
      maxWidth: '100% ',
      width: 'auto !important',
      '&:hover': {
        backgroundColor: theme.palette.primary.adgmHover,
        color: theme.palette.primary.white,
        border: 'none',
      },
    },
    delBtn: {
      maxWidth: '40px',
      padding: '10px',
    },
    fileUploadContainer: {
      padding: '1.5em 1em',
    },
    docContainer: {
      marginBottom: '8px',
    },
    docName: {
      fontSize: '14px',
    },
    docHeading: {
      background: theme.palette.primary.grey,
      padding: '20px 1em',
      marginBottom: '0px',
    },
  },
  modalMain: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalpaper: {
    position: 'absolute',
    width: '50%',
    backgroundColor: '#fff',
    padding: '24px',
    borderRadius: '10px',
    fontSize: '16px',
  },
  modal: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    width: '100%',
    maxWidth: '784px',
    position: 'relative',
    '& $Title': {
      marginBottom: '32px',
    },
    '& $crossIconimg': {
      position: 'absolute',
      right: '24px',
      top: '31px',
    },
    '& $unitinputControl': {
      '& > p': {
        display: 'block',
        marginBottom: '9px',
        fontWeight: '400',
        color: '#8C9099',
        fontSize: '12px',
        '& span': {
          color: '#8C9099',
          fontSize: '12px',
        },
      },
      '& textarea': {
        padding: '21px 16px',
        width: '100%',
        border: '1px solid #CED1D6',
        borderRadius: '4px',
        minHeight: '160px',
        fontSize: '16px',
        [theme.breakpoints.down('sm')]: {
          height: '100% !important',
        },
      },
      '& fieldset': {
        border: '1px solid #CED1D6',
        borderRadius: '4px',
      },
    },
    '& $formControl': {
      gridTemplateColumns: '1fr',
    },
    '& $modaltitlehead': {
      display: 'block',
      '& img': {
        display: 'none',
      },
    },
  },
  modaltitlehead: {},
  Title: {
    fontWeight: '600',
    marginBottom: '5px',
    fontSize: '16px',
  },
  innerModalAccept: {
    position: 'relative',
    '& $crossIconimg': {
      position: 'absolute',
      right: '0',
      top: '0',
    },
    '& h1': {
      marginBottom: '24px',
      fontSize: '20px',
    },
    '& h2': {
      marginBottom: '28px',
      fontWeight: '400',
      fontSize: '16px',
    },
  },
  crossIconimg: {},
  modalBtnholder: {
    display: 'flex',
    width: '100%',
    marginTop: '20px',
  },
  btns: {
    width: '50%',
  },
  TerminateBtn: {
    fontSize: '16px',
    color: '#342D3D',
    minWidth: '151px',
    border: '1px solid #342D3D',
    textTransform: 'none',
    marginRight: '16px',
    borderRadius: '4px',
    transition: 'none',
    background: '#fff',
    '& img': {
      marginRight: '6px',
      width: '16px',
    },
    '&:hover': {
      '& img': {
        filter: 'invert(1)',
      },
      color: theme.palette.primary.white,
      border: 'none',
      background: theme.palette.primary.adgmHover, // Corrected "background" spelling
    },
  },
  accptBtn: {
    background: theme.palette.primary.main,
    fontSize: '16px',
    color: '#fff',
    minWidth: '151px',
    textTransform: 'none',
    borderRadius: '4px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '0px !important',
      fontSize: '14px !important',
      height: '50px !important',
    },
    '&:hover': {
      border: 'none',
      background: theme.palette.primary.adgmHover, // Corrected "background" spelling
    },
  },
  pdfArea: {
    borderRadius: '4px',
    border: '1px solid #CED1D6',
    backgroundColor: '#F8F8F8',
    padding: '2px',
  },
  infoPanel: {
    width: '100%',
  },
  infoSection: {
    display: 'inline-flex',
    flexDirection: 'column',
    gap: '8px',
  },
  bold: {
    fontWeight: '600',
  },
  disableText: {
    color: '#ced1d6',
  },
  disableFileActions: {
    color: '#CED1D6',
    border: '1px solid #CED1D6 !important',
  },
});

export default styles;
